// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';
import { min, max, sum } from 'd3-array';

angular.module('services.ChartService', []).service('ChartService', function () {
  return {
    /**
     * Gets the real size (width/height) without paddings of the
     * specified element
     *
     * @param {object} container - DOM object of the element to get the size
     * @returns {object}         - Object with the width and height of the element
     */
    getSize: function (container) {
      var getCSSProperty = function (property) {
        var result = 0;

        if (container && property) {
          var element = window.getComputedStyle(container, null);
          result = parseFloat(element.getPropertyValue(property));
        }

        return result;
      };

      var padding = {
        top: getCSSProperty('padding-top'),
        bottom: getCSSProperty('padding-bottom'),
        left: getCSSProperty('padding-left'),
        right: getCSSProperty('padding-right'),
      };

      return {
        width: getCSSProperty('width') - padding.left - padding.right,
        height: getCSSProperty('height') - padding.top - padding.bottom,
      };
    },
    /**
     * Erases the specified chart
     *
     * @param {object} chart - DOM object of the SVG element
     */
    erase: function (chart) {
      while (chart.lastChild) {
        chart.removeChild(chart.lastChild);
      }
    },
    /**
     * Sorts the data and get the max, min and total
     *
     * @param {Array} data - Array of data for the visualization
     * @returns {object}   - Object with the sorted data, min, max and total
     */
    getData: function (data) {
      const value_sorted = data.slice().sort(function (a, b) {
        return b.value - a.value;
      });

      const key_sorted = data.slice().sort(function (a, b) {
        return a.key > b.key ? 1 : -1;
      });

      return {
        value_sorted,
        key_sorted,
        min: min(data, ({value}) => value),
        max: max(data, ({value}) => value),
        total: sum(data, ({value}) => value),
      };
    },
  };
});
